import React from "react";
import styles from "./index.module.scss";

const EditProduct = () => {
  return <div>EditProduct</div>;
};

export default EditProduct;
